<div class="background"></div>
<div class="container">
    <div class="spinner-box">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
</div>